export const PLATFORM_NAME = 'LogicPanel'
export const PLATFORM_DESC = '2.0'
export const API_URL = process.env.REACT_APP_API_URL
const globals = {
  PLATFORM_NAME,
  PLATFORM_DESC,
}
export default globals
